<div class="kh-table-container">
  <table class="kh-primary-table">
    <ng-content></ng-content>
  </table>
</div>
